<template>
  <div v-if="memberShow" id="PersonalInformation" style="padding: 0 1em">
    <div class="course_title">新申請</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>

          <tr align="left">
            <td>獎金匯款資料</td>
            <td><div class="input-group-text">請提供本人帳戶</div></td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>銀行名稱</td>
            <td>
              <div class="input-group-text">{{ queryInfo.postname }}</div>
            </td>
            <td>分行名稱</td>
            <td>
              <div class="input-group-text">{{ queryInfo.postsubName }}</div>
            </td>
          </tr>

          <tr align="left">
            <td>分行代碼(必填7碼)</td>
            <td>
              <div class="input-group-text">{{ queryInfo.postsubID }}</div>
            </td>
            <td>銀行帳號</td>
           <td>
  <input v-model="queryInfo.postno" @input="validatePostno" class="input-group-text" />
  <div v-if="postnoError" class="error-msg">
    銀行帳號不得少於10碼
  </div>
</td>
          </tr>

          <tr align="left">
            <td>金融帳戶封面影本</td>

            <td>
              <div class="input-group-text">
                <div v-if="mode">
                  <span v-if="queryInfo.file[0].RowId != undefined">
                    <a
                      :href="
                        './WebApi/Common/GetDocumentFile2/' +
                        queryInfo.file[0].RowId
                      "
                      target="_blank"
                    >
                      <img src="@/assets/images/disk.png" />
                    </a>
                    {{
                      queryInfo.file[0].RowId != undefined
                        ? queryInfo.file[0].name
                        : ""
                    }}
                  </span>
                </div>
                <div v-else></div>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>申請項目</td>
            <td>
              <div>
                <b-form-select
                  v-model="selected1"
                  :options="options1"
                  v-on:change="getSelected1Item()"
                ></b-form-select>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left" v-if="ItemMode == 2 || ItemMode == 3">
            <td><span style="color: #f00">＊</span>主辦單位</td>
            <td>
              <div>
                <b-form-select
                  v-model="selected2"
                  :options="options2"
                ></b-form-select>
              </div>
            </td>
            <td></td>
          </tr>
          <tr align="left" v-if="ItemMode == 2 || ItemMode == 3">
            <td>
              <span style="color: #f00">＊</span
              >競賽分組(團體之定義為2人以上(含2人))
            </td>

            <td>
              <div>
                <b-form-select
                  v-model="selected3"
                  :options="options3"
                ></b-form-select>
              </div>
            </td>
            <td><span style="color: #f00">＊</span>組別</td>
            <td>
              <div>
                <b-form-select
                  v-model="selected4"
                  :options="options4"
                ></b-form-select>
              </div>
            </td>
          </tr>
          <tr align="left" v-if="ItemMode == 2 || ItemMode == 3">
            <td><span style="color: #f00">＊</span>競賽種類名稱</td>
            <td>
              <b-form-select v-model="queryInfo.sn">
                <option
                  v-for="(selectOption) in TypeNameList"
                  :key="selectOption.sn"
                  :value="selectOption.sn"
                >
                  {{ selectOption.typeName }}
                </option>
              </b-form-select>
            </td>
            <td><span style="color: #f00">＊</span>名次</td>
            <td>
              <input
                type="number"
                class="form-control"
                v-model="queryInfo.ranking"
                pattern="/^-?\d+$/"
                onKeyPress="if(this.value.length==1) return false;"
                required
              />
            </td>
          </tr>

          <tr align="left" v-if="ItemMode == 3">
            <td><span style="color: #f00">＊</span>秩序冊</td>

            <td>
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="file1"
                @input="fileChange(0)"
                placeholder="上傳秩序冊"
                accept="image/jpeg, image/png, image/gif, application/pdf"
              ></b-form-file>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left" v-if="ItemMode == 3">
            <td><span style="color: #f00">＊</span>得獎證明文件影印本</td>

            <td>
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="file2"
                @input="fileChange(1)"
                placeholder="上傳得獎證明文件影印本"
                accept="image/jpeg, image/png, image/gif, application/pdf"
              ></b-form-file>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left" v-if="ItemMode == 3">
            <td>競賽辦法及賽程時間內容資料</td>

            <td>
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="file3"
                @input="fileChange(2)"
                placeholder="上傳競賽辦法及賽程時間內容資料"
                accept="image/jpeg, image/png, image/gif, application/pdf"
              ></b-form-file>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr style="text-align: center">
            <td></td>
            <td>
              <button
                class="btn active bg-info text-white rounded"
                @click="addNewCase()"
              >
                送出資料
              </button>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "AddNewCase",
  // props: [
  //   'memberShow2',
  //   'inputData2'
  // ],
  data() {
    return {
      TypeNameList: null,
      ItemMode: 2,
      selected1: null,
      options1: [
        { value: null, text: "請選擇" },
        { value: 0, text: "運動績優保送生" },
        { value: 1, text: "校內比賽" },
        { value: 2, text: "校外比賽" },
      ],
      selected2: null,
      options2: [
        { value: null, text: "請選擇" },
        { value: 0, text: "體育室" },
        { value: 1, text: "中華民國大專院校體育總會(含聯賽)" },
        { value: 2, text: "其他" },
      ],
      selected3: null,
      options3: [
        { value: null, text: "請選擇" },
        { value: 0, text: "公開組個人賽" },
        { value: 1, text: "一般組個人賽" },
        { value: 2, text: "公開組團體賽" },
        { value: 3, text: "一般組團體賽" },
      ],
      selected4: null,
      options4: [
        { value: null, text: "請選擇" },
        { value: 0, text: "男子組" },
        { value: 1, text: "女子組" },
        { value: 2, text: "混合組" },
      ],

      memberShow: this.$store.state.user2,
      inputData: this.$store.state.inputData,
      inputData2: null,
      mode: false,
      file1: null,
      file2: null,
      file3: null,
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        //   postid: "", //銀行總代號
        sn:null,
        id: "",
        stdID: "",
        postname: "", //銀行名稱
        postno: "", //銀行帳號
        postnoError: false,
        postsubID: "", //分行代碼(必填7碼)前三碼是銀行總代號
        postsubName: "", //分行名稱
        Info1: [],
        Info2: [],
        Info3: [],
        file: [
          { name: "", RowId: "" },
          { name: "", RowId: "" },
          { name: "", RowId: "" },
          { name: "", RowId: "" },
        ],
        sid: "",
        RowId: "",
        item: null,
        unit: null,
        cGroup: null,
        typeName: null,
        group: null,
        ranking: null,
        Divis: null,
        Schyy: null,
        Smt: null,
        Dptcd: null,
        Sex: null,
        UpdateUser: null,
      },
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    validatePostno() {
      this.postnoError = this.queryInfo.postno.length < 10;
    },
    CaseSelect(id) {
      this.$emit("CaseSelect", id);
    },
    getSelected1Item() {
      if (this.selected1 == 0) {
        this.selected2 = 99;
        this.selected3 = 99;
        this.selected4 = 99;
      //  var re=/保送生/ ;
      //   this.TypeNameList.find(object => {
      //     if (object.typeName.trim().match(re)) {
      //       this.queryInfo.typeName = object.typeName;
      //     }
      //   });

        this.queryInfo.typeName="運動績優保送生";
         this.queryInfo.sn=12;
        this.queryInfo.ranking = 0;
        this.ItemMode = 1;
      } else if (this.selected1 == 1) {
        this.ItemMode = 2;
      } else if (this.selected1 == 2) {
        this.ItemMode = 3;
      }
    },
    isEmpty(data) {
      return data != null && data != undefined && data.length > 0
        ? false
        : true;
    },
    checkSaveData() {
      var msg = "";

      if (this.selected1 == null) {
        msg = "請選擇申請項目";
      } else if (this.selected2 == null) {
        msg = "請選擇主辦單位";
      } else if (this.selected3 == null) {
        msg = "請選擇競賽分組";
      } else if (this.selected4 == null) {
        msg = "請選擇組別";
      } else if (this.queryInfo.sn == null) {
        msg = "請輸入競賽種類名稱";
      } else if (this.queryInfo.ranking == null) {
        msg = "請輸入名次";
      } else if (this.isEmpty(this.queryInfo.file[0].name)) {
        msg = "請上傳金融帳戶封面影本";
      }
        else if (this.queryInfo.postno.length < 10) {
        msg = "請輸入銀行帳號長度不得少於10";
      } else if (this.ItemMode == 3 && this.isEmpty(this.file1.name)) {
        msg = "請上傳秩序冊";
      } else if (this.ItemMode == 3 && this.isEmpty(this.file2.name)) {
        msg = "請上傳得獎證明文件影印本";
      }
      return msg;
    },
    generateRandomString() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < 16; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
},

    fileChange(index) {
      //  var vm = this;
      this.formData = new FormData();
  var header1 =   this.generateRandomString() ;
  var header2 =   this.generateRandomString() ;
  var header3 =   this.generateRandomString() ;

      if (index == 0) {

        this.formData.append(header1, this.file1);
      }
      if (index == 1) {

        this.formData.append(header2, this.file2);
      }

      if (index == 2) {

        this.formData.append(header3, this.file3);
      }

      this.$http
        .post("./WebApi/Common/UploadV2", this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) this.queryInfo.Info1 = response.data;
            else if (index == 1) this.queryInfo.Info2 = response.data;
            else if (index == 2) this.queryInfo.Info3 = response.data;
          } else {
            tools.showAlert(vm, "danger", "上傳檔案失敗，請重新上傳" + error);
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗，請重新上傳" + error);
        });
    },

    addNewCase: function () {
      var msg = this.checkSaveData();
      if (msg.length != 0) {
        alert(msg);
        return null;
      }

      let vm = this;
      vm.queryInfo.sid = vm.inputData.usrData.id;
      vm.queryInfo.Divis = vm.inputData.usrData.divis;
      vm.queryInfo.Schyy = vm.inputData.usrData.schyy;
      vm.queryInfo.Smt = vm.inputData.usrData.smt;
      vm.queryInfo.Dptcd = vm.inputData.usrData.dptcd;
      vm.queryInfo.Sex = vm.inputData.usrData.sex;
      vm.queryInfo.item = vm.selected1;
      vm.queryInfo.unit = vm.selected2;
      vm.queryInfo.cGroup = vm.selected3;
      vm.queryInfo.group = vm.selected4;
      vm.queryInfo.UpdateUser = vm.inputData.usrData.id;

      const selectedSn = this.TypeNameList.find(x => x.sn === vm.queryInfo.sn);

if (selectedSn) {
  vm.queryInfo.typeName = selectedSn.typeName;
}

      if (vm.mode == true) {
        //console.log(vm.queryInfo);
        //新增
        this.$http
          .put("./WebApi/SportsExcellent/AddNewCase/", vm.queryInfo)
          .then((response) => {
            if (0 < response.data) {
              alert("新增上傳成功");
              this.CaseSelect(1);
              //   this.$store.dispatch('actionLogin2', vm.memberShow);
              //  this.$store.dispatch('actionLogin2Data', vm.inputData);
              // vm.$router.push({ path:'StdLogin' }) ;
              //window.location.replace("/StdLogin");
            } else if (response.data == 0) alert("已有資料");
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    getBankData() {
      let vm = this;

      vm.queryInfo.sid = vm.inputData.usrData.id;
      this.$http
        .get("./WebApi/SportsExcellent/GetBankData/".concat(vm.queryInfo.sid))
        .then((response) => {
          if (response.data != null && response.data != 0) {
            vm.queryInfo.id = response.data.id;
            vm.queryInfo.stdID = response.data.id;
            vm.queryInfo.postname = response.data.postname;
            vm.queryInfo.postno = response.data.postno;
            vm.queryInfo.postsubID = response.data.postsubID;
            vm.queryInfo.postsubName = response.data.postsubName;
            if (response.data.attachInfoString != null) {
              let jsonArr = JSON.parse(response.data.attachInfoString);
              vm.queryInfo.file[0].name = jsonArr.FileNm;
              vm.queryInfo.file[0].RowId = jsonArr.RowId;
              vm.mode = true;
            }
          } else {
            alert("請先新增銀行個人資料");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    getAllTypeName(mode) {
      let vm = this;
      this.$http
        .get("./WebApi/SportsExcellent/GetAllTypeName/".concat(mode))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.TypeNameList = response.data;

          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
  },
  created() {
    console.log("======created AddNewCaseView =====");
    this.getBankData();
  },
  mounted() {
    console.log("======mounted AddNewCaseView  =====");
    this.getAllTypeName(0);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
